import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class ServicoOrcamentoApiClient {

    async buscarTodos(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/servico-orcamento',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async cadastrar(dados) {
        return axios.post('/servico-orcamento/inserir/', dados)
    }

    async editar(dados) {
        return axios.put('/servico-orcamento/atualizar/', dados)
    }

    async excluir(dados) {
        return axios.delete(`/servico-orcamento/deletar/${dados.orcamentoId}/${dados.servicoId}`)
    }


}

export default new ServicoOrcamentoApiClient()